// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29Qsg","location":"Header_location__1tGKZ"};